import React from 'react';
import {Button} from '@albert-io/atomic';

import './assets/social-button.scss';

interface Props extends PropsWithChildrenRequired {
  disabled: boolean;
  href: string;
  provider: 'clever' | 'google';
}

export default function SocialButton({children, disabled, href, provider}: Props) {
  return (
    <Button
      as='a'
      href={href}
      color={`vendor-${provider}`}
      className='sso-button'
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
